import React from 'react';
import { withRouter } from 'react-router';
import LocalizedStrings from 'react-localization';
import RatingStars from './RatingStars';

function CompareTable(props) {
  const handlerRemove = (company, programm) => {
    const { tarif } = props.compare.filter((item) => item.tarif.name === programm)[0];
    props.removeCompareFromList({
      id: company,
      tarif
    });
  };

  const handleBack = (e) => {
    e.preventDefault();
    // props.history.push({
    //   pathname: props.locale === 'ua' ? '/uk/kasko/info' : '/kasko/info',
    //   search: props.location.search
    // });
    props.history.goBack();
  };

  const strings = new LocalizedStrings({
    ru: {
      get: 'Получи',
      back: 'Вернуться назад',
      choose: 'Выбрать',
      category: 'Категория условия',
      cashback: 'кешбэка',
      sale: 'акция',
      polis: 'Полис',
      mark: 'оценок',
      reviews: 'Отзывы о компании',
      more: 'Подробнее',
      franchiseDamage: 'повреждения',
      franchiseStealing: 'угон'
    },
    ua: {
      get: 'Отримай',
      back: 'Повернутися назад',
      choose: 'Обрати',
      category: 'Категорія умови',
      cashback: 'кешбеку',
      sale: 'акція',
      polis: 'Поліс',
      mark: 'оцінок',
      reviews: 'Відгуки про компанію',
      more: 'Детальніше',
      franchiseDamage: 'пошкодження',
      franchiseStealing: 'викрадення'
    },
  });

  strings.setLanguage(props.locale);

  return (
    <div className="table-compare compare_page">
      <div className="mob-btn compare-head">
        <a href="#" className="btn btn-back" onClick={handleBack}>
          <svg width={6} height={10} viewBox="0 0 6 10" fill="none"><path d="M5 9L1 5L5 1" stroke="#374656" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>
          {strings.back}
        </a>
      </div>
      <table>
        <thead>
          <tr>
            <th className="compare-item compare-list">
              <div className="compare-head">
                <a onClick={handleBack} href="#/" className="btn btn-back"><svg width={6} height={10} viewBox="0 0 6 10" fill="none"><path d="M5 9L1 5L5 1" stroke="#374656" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>{strings.back}</a>
              </div>
            </th>
            {props.compare.map((item, id) => (
              <th className="compare-item compare-tariff" data-id="i-1" key={id}>
                <div className="compare-head">
                  <div className="action-block">
                  </div>
                  <div className="flex flex_j-space-between">
                    <div className="logo-company">
                      <picture>
                        <source type="image/webp" srcSet={item.insuranceCompanyLogoWebp} />
                        <img src={item.insuranceCompanyLogoPng} alt={item.insuranceCompanyName} />
                      </picture>
                    </div>
                    <div className="dalete" id={item.insuranceCompanyCode} onClick={() => handlerRemove(item.insuranceCompanyCode, item.tarif.name)}>
                      <svg width={11} height={11} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.00098 1L9.34791 9.34783" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path d="M9.34668 1L0.999746 9.34783" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </div>

                  <div className="price">
                    {
                      item.tarif.amountWithDiscount ?
                        (Math.floor(item.tarif.amountWithDiscount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")) : (Math.floor(item.tarif.amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "))
                    }
                    &nbsp;грн
                  </div>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {/* program */}
          <tr className="tr-bg tr-mob">
            <td colSpan={props.compare.length}><div className="m-tit">Пакет</div></td>
          </tr>
          <tr className="tr-bg">
            <td className="compare-item compare-list compare-body">
              <div className="item">
                <p>Пакет</p>
              </div>
            </td>
            {props.compare.map((item, id) => (
              <td className="compare-item compare-tariff compare-body" key={id}>
                <div className="item">
                  <p>«{item.tarif.name}»</p>
                </div>
              </td>
            ))}
          </tr>
          {/* End program */}

          {/* tarif */}
          <tr className="tr-mob">
            <td colSpan={props.compare.length}><div className="m-tit">Тариф</div></td>
          </tr>
          <tr>
            <td className="compare-item compare-list compare-body">
              <div className="item">
                <p>Тариф</p>
              </div>
            </td>
            {props.compare.map((item, id) => (
              <td className="compare-item compare-tariff compare-body" key={id}>
                <div className="item">
                  <p>{item.tarif.tarif}%</p>
                </div>
              </td>
            ))}
          </tr>
          {/* End tarif */}

          {/* franchise damage */}
          <tr className="tr-bg tr-mob">
            <td colSpan={props.compare.length}><div className="m-tit">Франшиза ({strings.franchiseDamage})</div></td>
          </tr>
          <tr className="tr-bg">
            <td className="compare-item compare-list compare-body">
              <div className="item">
                <p>Франшиза ({strings.franchiseDamage})</p>
              </div>
            </td>
            {props.compare.map((item, id) => (
              <td className="compare-item compare-tariff compare-body" key={id}>
                <div className="item">
                  <p>{item.tarif.dtpFranchise}%</p>
                </div>
              </td>
            ))}
          </tr>
          {/* End franchise damage */}

          {/* franchise stealing */}
          <tr className="tr-mob">
            <td colSpan={props.compare.length}><div className="m-tit">Франшиза ({strings.franchiseStealing})</div></td>
          </tr>
          <tr>
            <td className="compare-item compare-list compare-body">
              <div className="item">
                <p>Франшиза ({strings.franchiseStealing})</p>
              </div>
            </td>
            {props.compare.map((item, id) => (
              <td className="compare-item compare-tariff compare-body" key={id}>
                <div className="item">
                  <p>{item.tarif.ugonFranchise}%</p>
                </div>
              </td>
            ))}
          </tr>
          {/* End franchise stealing */}
        </tbody>
      </table>
    </div>
  );
}

export default withRouter(CompareTable);
